var _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "uil-ellipsis",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 50,
    r: 15,
    fill: "#0058ff",
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "anir11",
    attributeName: "r",
    from: 0,
    to: 15,
    begin: "0s;anir14.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir12",
    attributeName: "r",
    from: 15,
    to: 15,
    begin: "anir11.end",
    dur: "0.625s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir13",
    attributeName: "r",
    from: 15,
    to: 0,
    begin: "anir12.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir14",
    attributeName: "r",
    from: 0,
    to: 0,
    begin: "anir13.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix11",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "0s;anix18.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix12",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "anix11.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix13",
    attributeName: "cx",
    from: 16,
    to: 50,
    begin: "anix12.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix14",
    attributeName: "cx",
    from: 50,
    to: 50,
    begin: "anix13.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix15",
    attributeName: "cx",
    from: 50,
    to: 84,
    begin: "anix14.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix16",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "anix15.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix17",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "anix16.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix18",
    attributeName: "cx",
    from: 84,
    to: 16,
    begin: "anix17.end",
    dur: "0.125s",
    fill: "freeze"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 15,
    fill: "#08b2fa",
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "anir21",
    attributeName: "r",
    from: 15,
    to: 15,
    begin: "0s;anir25.end",
    dur: "0.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir22",
    attributeName: "r",
    from: 15,
    to: 0,
    begin: "anir21.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir23",
    attributeName: "r",
    from: 0,
    to: 0,
    begin: "anir22.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir24",
    attributeName: "r",
    from: 0,
    to: 15,
    begin: "anir23.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir25",
    attributeName: "r",
    from: 15,
    to: 15,
    begin: "anir24.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix21",
    attributeName: "cx",
    from: 16,
    to: 50,
    begin: "0s;anix28.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix22",
    attributeName: "cx",
    from: 50,
    to: 50,
    begin: "anix21.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix23",
    attributeName: "cx",
    from: 50,
    to: 84,
    begin: "anix22.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix24",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "anix23.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix25",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "anix24.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix26",
    attributeName: "cx",
    from: 84,
    to: 16,
    begin: "anix25.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix27",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "anix26.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix28",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "anix27.end",
    dur: "0.125s",
    fill: "freeze"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 15,
    fill: "#86eafa",
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "anir31",
    attributeName: "r",
    from: 15,
    to: 15,
    begin: "0s;anir35.end",
    dur: "0.25s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir32",
    attributeName: "r",
    from: 15,
    to: 0,
    begin: "anir31.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir33",
    attributeName: "r",
    from: 0,
    to: 0,
    begin: "anir32.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir34",
    attributeName: "r",
    from: 0,
    to: 15,
    begin: "anir33.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir35",
    attributeName: "r",
    from: 15,
    to: 15,
    begin: "anir34.end",
    dur: "0.375s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix31",
    attributeName: "cx",
    from: 50,
    to: 84,
    begin: "0s;anix38.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix32",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "anix31.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix33",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "anix32.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix34",
    attributeName: "cx",
    from: 84,
    to: 16,
    begin: "anix33.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix35",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "anix34.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix36",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "anix35.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix37",
    attributeName: "cx",
    from: 16,
    to: 50,
    begin: "anix36.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix38",
    attributeName: "cx",
    from: 50,
    to: 50,
    begin: "anix37.end",
    dur: "0.125s",
    fill: "freeze"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 50,
    r: 15,
    fill: "#08b2fa",
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "anir41",
    attributeName: "r",
    from: 15,
    to: 0,
    begin: "0s;anir44.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir42",
    attributeName: "r",
    from: 0,
    to: 0,
    begin: "anir41.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir43",
    attributeName: "r",
    from: 0,
    to: 15,
    begin: "anir42.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anir44",
    attributeName: "r",
    from: 15,
    to: 15,
    begin: "anir43.end",
    dur: "0.625s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix41",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "0s;anix48.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix42",
    attributeName: "cx",
    from: 84,
    to: 16,
    begin: "anix41.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix43",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "anix42.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix44",
    attributeName: "cx",
    from: 16,
    to: 16,
    begin: "anix43.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix45",
    attributeName: "cx",
    from: 16,
    to: 50,
    begin: "anix44.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix46",
    attributeName: "cx",
    from: 50,
    to: 50,
    begin: "anix45.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix47",
    attributeName: "cx",
    from: 50,
    to: 84,
    begin: "anix46.end",
    dur: "0.125s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "anix48",
    attributeName: "cx",
    from: 84,
    to: 84,
    begin: "anix47.end",
    dur: "0.125s",
    fill: "freeze"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderDot);
export default __webpack_public_path__ + "static/media/loader-dot.095449fbf634000d84794f888b0ff112.svg";
export { ForwardRef as ReactComponent };